import Vue from 'vue';
import Snackbar from '@/components/snackbar/snackbar.vue';

export let snackbarProgrammatic = {
    open(params: SnackbarConfig): Snackbar {
        let message = '';

        if (typeof params === 'string') {
            message = params;
        }

        const defaultParam = {
            message,
            type: 'is-success',
            position: 'is-top',
        };

        const propsData = Object.assign(defaultParam, params);

        const vm = typeof window !== 'undefined' && (window as any).Vue ? (window as any).Vue : Vue;

        const snackbarComponent = vm.extend(Snackbar);

        return new snackbarComponent({
            propsData,
            el: document.createElement('div'),
        });
    },
};

const plugin = {
    install(vue: any) {
        Vue.prototype.$snackbar = snackbarProgrammatic;
    },
};

type ColorModifiers = 'is-white' | 'is-black' | 'is-light' | 'is-dark' | 'is-primary' | 'is-info' | 'is-success' | 'is-warning' | 'is-danger' | string;
type GlobalPositions = 'is-top-right' | 'is-top' | 'is-top-left' | 'is-bottom-right' | 'is-bottom' | 'is-bottom-left';

export interface SnackbarConfig {
  message: string;
  type?: ColorModifiers;
  position?: GlobalPositions;
  duration?: number;
  container?: string;
  actionText?: string | null;
  queue?: boolean;
  indefinite?: boolean;
  onAction?: () => any;
}

declare module 'vue/types/vue' {
    interface Vue {
        $snackbar: typeof snackbarProgrammatic;
    }
}

export default plugin;
